module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07511_logo_200x200.c5b9a5e9.png";